module.exports = __webpack_public_path__ + "static/media/star.cbd1b4bb.png";